// TC Moving Dashboard v3.0 - Custos Detalhados
import { useState, useEffect, useMemo, useRef } from "react";

const STORAGE_KEY = "tc_moving_services";
const COSTS_KEY = "tc_costs";
const BUSINESS_SPLIT = { lucro: 0.60, variavel: 0.25, manutencao: 0.10, fixo: 0.05 };
const MIN_RATE_PER_MILE = 1.5;
const SERVICE_TYPES = ["Load Board (Frete)", "Mudança Residencial", "Junk Removal"];
const MONTHS_FULL = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const MONTHS = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
const DAYS_SHORT = ["D","S","T","Q","Q","S","S"];
const DAYS_PT = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];

const MANUT_ITEMS = [
  {id:"oleo",      nome:"Óleo Motor",           custoEst:140,  periodo:1},
  {id:"alinha",    nome:"Alinhamento",           custoEst:180,  periodo:3},
  {id:"pneus",     nome:"Pneus (jogo completo)", custoEst:1200, periodo:12},
  {id:"freios",    nome:"Freios Dianteiros",      custoEst:850,  periodo:12},
  {id:"fluido",    nome:"Fluido/Transmissão",     custoEst:550,  periodo:12},
  {id:"sensores",  nome:"Sensores",               custoEst:500,  periodo:12},
  {id:"suspensao", nome:"Suspensão Preventiva",   custoEst:1200, periodo:12},
  {id:"door",      nome:"Door Rollers/Tracks",    custoEst:500,  periodo:24},
  {id:"bearing",   nome:"Wheel Bearing",          custoEst:550,  periodo:36},
  {id:"bateria",   nome:"Bateria",                custoEst:280,  periodo:36},
  {id:"ac",        nome:"AC Compressor",          custoEst:1500, periodo:36},
  {id:"alternador",nome:"Alternador",             custoEst:900,  periodo:36},
];

function defCosts() {
  return {
    variavel: { gas: { est: 1000, real: {} }, ped: { est: 400, real: {} } },
    manutencao: {},
    fixo: { segCarro: { est: 0, real: {} }, segCom: { est: 0, real: {} } }
  };
}
function ldCosts() { try { return JSON.parse(localStorage.getItem(COSTS_KEY)) || defCosts(); } catch { return defCosts(); } }
function svCosts(d) { localStorage.setItem(COSTS_KEY, JSON.stringify(d)); }
function mkStr(y, m) { return y + "_" + m; }
function allMonths() {
  const res = [], n = new Date();
  for (let i = 11; i >= 0; i--) {
    const d = new Date(n.getFullYear(), n.getMonth() - i, 1);
    res.push({ y: d.getFullYear(), m: d.getMonth() });
  }
  return res;
}

function formatCurrency(v) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v || 0);
}
function formatDate(d) {
  if (!d) return "-";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
}
function fmt12(t) {
  if (!t) return "";
  let h, m;
  if (typeof t === "number") { h = t; m = 0; }
  else { [h, m] = t.split(":").map(Number); }
  h = h % 24;
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = (h % 12) || 12;
  return `${h12}:${String(m || 0).padStart(2, "0")} ${ampm}`;
}
function todayKey() { return new Date().toISOString().split("T")[0]; }
function fmtMes(y, m) { return MONTHS[m] + "/" + y; }

const emptyForm = {
  tipo: SERVICE_TYPES[0],
  origemNumero: "", origemEndereco: "", origemZip: "", origemLocal: "", origemContato: "",
  destinoNumero: "", destinoEndereco: "", destinoZip: "", destinoLocal: "", destinoContato: "",
  origem: "", destino: "",
  milhas: "", peso: "", pecas: "1",
  dataPickup: "", horaPickup: "08:00",
  dataEntrega: "", horaEntrega: "17:00",
  dataPagamento: "", horaPagamento: "12:00",
  pago: false, valor: "", notas: ""
};

const EV_COLORS = {
  pickup:  { bg: "#276749", light: "#9ae6b4", label: "🚛 Pickup" },
  entrega: { bg: "#2b6cb0", light: "#90cdf4", label: "🏁 Entrega" },
};
function evColor(ev) { return ev._isDelivery ? EV_COLORS.entrega : EV_COLORS.pickup; }

// ── MODAL VARIAVEL ────────────────────────────────────────────
function ModalVariavel({ onClose }) {
  const [costs, setCosts] = useState(ldCosts);
  const months = allMonths();

  function save(updated) { setCosts(updated); svCosts(updated); }

  function updEst(tipo, val) {
    const c = { ...costs, variavel: { ...costs.variavel, [tipo]: { ...costs.variavel[tipo], est: parseFloat(val) || 0 } } };
    save(c);
  }
  function updReal(tipo, k, val) {
    const c = { ...costs, variavel: { ...costs.variavel, [tipo]: { ...costs.variavel[tipo], real: { ...costs.variavel[tipo].real, [k]: parseFloat(val) || 0 } } } };
    save(c);
  }

  const gasEst = costs.variavel.gas.est;
  const pedEst = costs.variavel.ped.est;
  const gasRealTotal = months.reduce((s, d) => s + (costs.variavel.gas.real[mkStr(d.y, d.m)] || 0), 0);
  const pedRealTotal = months.reduce((s, d) => s + (costs.variavel.ped.real[mkStr(d.y, d.m)] || 0), 0);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, minWidth: 320, maxWidth: 680, width: "95%", maxHeight: "85vh", overflowY: "auto", textAlign: "left" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 800, color: "#63b3ed" }}>⛽ Custos Variáveis</h2>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* Totais */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          {[
            { label: "⛽ Gasolina", est: gasEst * 12, real: gasRealTotal },
            { label: "🛣️ Pedágio", est: pedEst * 12, real: pedRealTotal },
          ].map(({ label, est, real }) => (
            <div key={label} style={{ background: "#1a202c", borderRadius: 8, padding: 12 }}>
              <div style={{ color: "#a0aec0", fontSize: 11, marginBottom: 4 }}>{label}</div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span style={{ color: "#718096" }}>Est. anual</span>
                <span style={{ color: "#63b3ed", fontWeight: 700 }}>{formatCurrency(est)}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span style={{ color: "#718096" }}>Real (12m)</span>
                <span style={{ color: real > est ? "#fc8181" : "#68d391", fontWeight: 700 }}>{formatCurrency(real)}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
                <span style={{ color: "#718096" }}>Diferença</span>
                <span style={{ color: real > est ? "#fc8181" : "#68d391", fontWeight: 700 }}>{real - est >= 0 ? "+" : ""}{formatCurrency(real - est)}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Estimativas base */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          <label style={S.label}>⛽ Estimativa Gasolina/mês
            <input style={S.input} type="number" defaultValue={gasEst} onBlur={e => updEst("gas", e.target.value)} />
          </label>
          <label style={S.label}>🛣️ Estimativa Pedágio/mês
            <input style={S.input} type="number" defaultValue={pedEst} onBlur={e => updEst("ped", e.target.value)} />
          </label>
        </div>

        {/* Tabela mensal */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead>
              <tr style={{ color: "#a0aec0", borderBottom: "1px solid #4a5568" }}>
                <th style={{ textAlign: "left", padding: "6px 4px" }}>Mês</th>
                <th style={{ textAlign: "right", padding: "6px 4px" }}>Est.Gas</th>
                <th style={{ textAlign: "right", padding: "6px 4px" }}>Real Gas</th>
                <th style={{ textAlign: "right", padding: "6px 4px" }}>Est.Ped</th>
                <th style={{ textAlign: "right", padding: "6px 4px" }}>Real Ped</th>
                <th style={{ textAlign: "right", padding: "6px 4px" }}>Variação</th>
              </tr>
            </thead>
            <tbody>
              {months.map(d => {
                const k = mkStr(d.y, d.m);
                const gasR = costs.variavel.gas.real[k] || 0;
                const pedR = costs.variavel.ped.real[k] || 0;
                const diff = (gasR + pedR) - (gasEst + pedEst);
                const dc = diff > 0 ? "#fc8181" : diff < 0 ? "#68d391" : "#a0aec0";
                return (
                  <tr key={k} style={{ borderBottom: "1px solid #2d3748" }}>
                    <td style={{ padding: "5px 4px", fontWeight: 700 }}>{fmtMes(d.y, d.m)}</td>
                    <td style={{ textAlign: "right", padding: "5px 4px", color: "#718096" }}>{formatCurrency(gasEst)}</td>
                    <td style={{ textAlign: "right", padding: "3px 2px" }}>
                      <input type="number" style={S.miniInput} defaultValue={gasR || ""} placeholder="0"
                        onBlur={e => updReal("gas", k, e.target.value)} />
                    </td>
                    <td style={{ textAlign: "right", padding: "5px 4px", color: "#718096" }}>{formatCurrency(pedEst)}</td>
                    <td style={{ textAlign: "right", padding: "3px 2px" }}>
                      <input type="number" style={S.miniInput} defaultValue={pedR || ""} placeholder="0"
                        onBlur={e => updReal("ped", k, e.target.value)} />
                    </td>
                    <td style={{ textAlign: "right", padding: "5px 4px", color: dc, fontWeight: 700 }}>
                      {gasR + pedR > 0 ? (diff >= 0 ? "+" : "") + formatCurrency(diff) : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ── MODAL MANUTENCAO ──────────────────────────────────────────
function ModalManutencao({ onClose }) {
  const [costs, setCosts] = useState(ldCosts);
  const [openItems, setOpenItems] = useState({});
  const months = allMonths();

  function save(updated) { setCosts(updated); svCosts(updated); }
  function updReal(itemId, k, val) {
    const c = { ...costs };
    if (!c.manutencao[itemId]) c.manutencao[itemId] = { real: {} };
    c.manutencao[itemId].real[k] = parseFloat(val) || 0;
    save(c);
  }
  function toggleItem(id) { setOpenItems(p => ({ ...p, [id]: !p[id] })); }

  const estAnual = MANUT_ITEMS.reduce((s, i) => s + (i.custoEst / i.periodo) * 12, 0);
  const realAnual = MANUT_ITEMS.reduce((s, item) => {
    const r = costs.manutencao[item.id] || { real: {} };
    return s + months.reduce((ms, d) => ms + (r.real[mkStr(d.y, d.m)] || 0), 0);
  }, 0);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, minWidth: 320, maxWidth: 700, width: "95%", maxHeight: "85vh", overflowY: "auto", textAlign: "left" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 800, color: "#f6ad55" }}>🔧 Manutenção</h2>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* Totais */}
        <div style={{ background: "#1a202c", borderRadius: 8, padding: 12, marginBottom: 16, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, textAlign: "center" }}>
          <div><div style={{ color: "#a0aec0", fontSize: 10 }}>EST. ANUAL</div><div style={{ color: "#f6ad55", fontWeight: 800, fontSize: 16 }}>{formatCurrency(estAnual)}</div></div>
          <div><div style={{ color: "#a0aec0", fontSize: 10 }}>REAL (12M)</div><div style={{ color: realAnual > estAnual ? "#fc8181" : "#68d391", fontWeight: 800, fontSize: 16 }}>{formatCurrency(realAnual)}</div></div>
          <div><div style={{ color: "#a0aec0", fontSize: 10 }}>DIFERENÇA</div><div style={{ color: realAnual > estAnual ? "#fc8181" : "#68d391", fontWeight: 800, fontSize: 16 }}>{realAnual - estAnual >= 0 ? "+" : ""}{formatCurrency(realAnual - estAnual)}</div></div>
        </div>

        {/* Items */}
        {MANUT_ITEMS.map(item => {
          const r = costs.manutencao[item.id] || { real: {} };
          const estMes = item.custoEst / item.periodo;
          const realTotal = months.reduce((s, d) => s + (r.real[mkStr(d.y, d.m)] || 0), 0);
          const estTotal = estMes * 12;
          const isOpen = openItems[item.id];

          return (
            <div key={item.id} style={{ marginBottom: 10, border: "1px solid #4a5568", borderRadius: 8, overflow: "hidden" }}>
              <div style={{ background: "#2d3748", padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}
                onClick={() => toggleItem(item.id)}>
                <div>
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{item.nome}</span>
                  <span style={{ color: "#718096", fontSize: 11, marginLeft: 8 }}>a cada {item.periodo} mês(es) · Est: {formatCurrency(item.custoEst)}</span>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <span style={{ fontSize: 11, color: "#a0aec0" }}>Est/ano: {formatCurrency(estTotal)}</span>
                  <span style={{ fontSize: 12, fontWeight: 700, color: realTotal > estTotal ? "#fc8181" : realTotal > 0 ? "#68d391" : "#a0aec0" }}>Real: {formatCurrency(realTotal)}</span>
                  <span style={{ color: "#718096" }}>{isOpen ? "▲" : "▼"}</span>
                </div>
              </div>
              {isOpen && (
                <div style={{ padding: "10px 14px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead>
                      <tr style={{ color: "#718096" }}>
                        <th style={{ textAlign: "left", padding: "4px" }}>Mês</th>
                        <th style={{ textAlign: "right", padding: "4px" }}>Estimado</th>
                        <th style={{ textAlign: "right", padding: "4px" }}>Real Gasto</th>
                        <th style={{ textAlign: "right", padding: "4px" }}>Dif.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {months.map(d => {
                        const k = mkStr(d.y, d.m);
                        const rv = r.real[k] || 0;
                        const dv = rv - estMes;
                        const dc = rv > 0 ? (rv > estMes ? "#fc8181" : "#68d391") : "#718096";
                        return (
                          <tr key={k} style={{ borderBottom: "1px solid #2d3748" }}>
                            <td style={{ padding: "4px", fontWeight: 600 }}>{fmtMes(d.y, d.m)}</td>
                            <td style={{ textAlign: "right", padding: "4px", color: "#718096" }}>{formatCurrency(estMes)}</td>
                            <td style={{ textAlign: "right", padding: "3px 2px" }}>
                              <input type="number" style={S.miniInput} defaultValue={rv || ""} placeholder="0"
                                onBlur={e => updReal(item.id, k, e.target.value)} />
                            </td>
                            <td style={{ textAlign: "right", padding: "4px", color: dc }}>
                              {rv > 0 ? (dv >= 0 ? "+" : "") + formatCurrency(dv) : "-"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── MODAL FIXO ────────────────────────────────────────────────
function ModalFixo({ onClose }) {
  const [costs, setCosts] = useState(ldCosts);
  const months = allMonths();

  function save(updated) { setCosts(updated); svCosts(updated); }
  function updEst(key, val) {
    const c = { ...costs, fixo: { ...costs.fixo, [key]: { ...costs.fixo[key], est: parseFloat(val) || 0 } } };
    save(c);
  }
  function updReal(key, k, val) {
    const c = { ...costs, fixo: { ...costs.fixo, [key]: { ...costs.fixo[key], real: { ...costs.fixo[key].real, [k]: parseFloat(val) || 0 } } } };
    save(c);
  }

  function FixoSection({ fkey, label }) {
    const d = costs.fixo[fkey] || { est: 0, real: {} };
    const est = d.est || 0;
    const realTotal = months.reduce((s, mo) => s + (d.real[mkStr(mo.y, mo.m)] || 0), 0);
    return (
      <div style={{ marginBottom: 20, border: "1px solid #4a5568", borderRadius: 8, overflow: "hidden" }}>
        <div style={{ background: "#2d3748", padding: "12px 14px" }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: "#fc8181", marginBottom: 10 }}>{label}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, textAlign: "center", marginBottom: 10 }}>
            <div><div style={{ color: "#a0aec0", fontSize: 10 }}>MENSAL EST.</div><div style={{ color: "#fc8181", fontWeight: 800 }}>{formatCurrency(est)}</div></div>
            <div><div style={{ color: "#a0aec0", fontSize: 10 }}>ANUAL EST.</div><div style={{ color: "#fc8181", fontWeight: 800 }}>{formatCurrency(est * 12)}</div></div>
            <div><div style={{ color: "#a0aec0", fontSize: 10 }}>REAL (12M)</div><div style={{ color: realTotal > est * 12 ? "#fc8181" : "#68d391", fontWeight: 800 }}>{formatCurrency(realTotal)}</div></div>
          </div>
          <label style={S.label}>Valor mensal estimado
            <input style={S.input} type="number" defaultValue={est} placeholder="0"
              onBlur={e => updEst(fkey, e.target.value)} />
          </label>
        </div>
        <div style={{ padding: "10px 14px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead>
              <tr style={{ color: "#718096" }}>
                <th style={{ textAlign: "left", padding: "4px" }}>Mês</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Estimado</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Real Pago</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Dif.</th>
              </tr>
            </thead>
            <tbody>
              {months.map(mo => {
                const k = mkStr(mo.y, mo.m);
                const rv = d.real[k] || 0;
                const dv = rv - est;
                const dc = rv > 0 ? (rv > est ? "#fc8181" : "#68d391") : "#718096";
                return (
                  <tr key={k} style={{ borderBottom: "1px solid #2d3748" }}>
                    <td style={{ padding: "4px", fontWeight: 600 }}>{fmtMes(mo.y, mo.m)}</td>
                    <td style={{ textAlign: "right", padding: "4px", color: "#718096" }}>{formatCurrency(est)}</td>
                    <td style={{ textAlign: "right", padding: "3px 2px" }}>
                      <input type="number" style={S.miniInput} defaultValue={rv || ""} placeholder="0"
                        onBlur={e => updReal(fkey, k, e.target.value)} />
                    </td>
                    <td style={{ textAlign: "right", padding: "4px", color: dc }}>
                      {rv > 0 ? (dv >= 0 ? "+" : "") + formatCurrency(dv) : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, minWidth: 320, maxWidth: 620, width: "95%", maxHeight: "85vh", overflowY: "auto", textAlign: "left" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 800, color: "#fc8181" }}>📋 Custos Fixos</h2>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>
        <FixoSection fkey="segCarro" label="🚗 Seguro do Carro" />
        <FixoSection fkey="segCom" label="🏢 Seguro Comercial" />
      </div>
    </div>
  );
}

// ── MAIN APP ──────────────────────────────────────────────────
export default function App() {
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem('tc_auth') === '1');
  const [pin, setPin] = useState('');
  const [pinError, setPinError] = useState(false);
  const [tab, setTab] = useState('dashboard');
  const [services, setServices] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);
  const [filterMonth, setFilterMonth] = useState("all");
  const [filterType, setFilterType] = useState("all");
  const [showDeleteId, setShowDeleteId] = useState(null);
  const [toast, setToast] = useState(null);
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [calMonth, setCalMonth] = useState(() => {
    const d = new Date(); return { y: d.getFullYear(), m: d.getMonth() };
  });
  const [selectedDay, setSelectedDay] = useState(todayKey());
  const [modalVariavel, setModalVariavel] = useState(false);
  const [modalManutencao, setModalManutencao] = useState(false);
  const [modalFixo, setModalFixo] = useState(false);
  const [calculatingMiles, setCalculatingMiles] = useState(false);
  const [hideValues, setHideValues] = useState(false);

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(services)); }, [services]);

  function showToast(msg, ok = true) { setToast({ msg, ok }); setTimeout(() => setToast(null), 2800); }
  const mask = (v) => hideValues ? "••••••" : v;

  const filtered = useMemo(() => {
    return services.filter(s => {
      const mm = filterMonth === "all" || (s.dataPickup && new Date(s.dataPickup).getMonth() === parseInt(filterMonth));
      const tt = filterType === "all" || s.tipo === filterType;
      return mm && tt;
    }).sort((a, b) => new Date(b.dataPickup) - new Date(a.dataPickup));
  }, [services, filterMonth, filterType]);

  const stats = useMemo(() => {
    const total = filtered.reduce((s, x) => s + Number(x.valor), 0);
    const miles = filtered.reduce((s, x) => s + Number(x.milhas || 0), 0);
    return {
      total, miles, count: filtered.length,
      lucro: total * BUSINESS_SPLIT.lucro,
      variavel: total * BUSINESS_SPLIT.variavel,
      manutencao: total * BUSINESS_SPLIT.manutencao,
      fixo: total * BUSINESS_SPLIT.fixo,
      avgPerMile: miles > 0 ? total / miles : 0,
      recebido: filtered.filter(x => x.pago).reduce((s, x) => s + Number(x.valor), 0),
      pendente: filtered.filter(x => !x.pago).reduce((s, x) => s + Number(x.valor), 0),
    };
  }, [filtered]);

  const monthlyChart = useMemo(() => {
    const map = {};
    services.forEach(s => {
      if (!s.dataPickup) return;
      const d = new Date(s.dataPickup);
      const key = `${d.getFullYear()}-${String(d.getMonth()).padStart(2, "0")}`;
      if (!map[key]) map[key] = { label: MONTHS[d.getMonth()], receita: 0, lucro: 0 };
      map[key].receita += Number(s.valor) || 0;
      map[key].lucro += (Number(s.valor) || 0) * BUSINESS_SPLIT.lucro;
    });
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b)).slice(-6).map(([, v]) => v);
  }, [services]);

  async function fetchCityFromZip(zip, prefix) {
    if (zip.length !== 5) return;
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${zip}&country=US&format=json&limit=1`);
      const data = await res.json();
      if (data[0]) {
        const parts = data[0].display_name.split(", ");
        setForm(p => ({ ...p, [`${prefix}Local`]: `${parts[0] || ""}, ${parts[2] || parts[1] || ""}` }));
      }
    } catch (e) {}
  }

  async function calcMilhasOSRM() {
    if (!form.origemZip || !form.destinoZip) { showToast("Preencha os ZIP codes para calcular.", false); return; }
    setCalculatingMiles(true);
    try {
      const geoO = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${form.origemZip}&country=US&format=json`).then(r => r.json());
      const geoD = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${form.destinoZip}&country=US&format=json`).then(r => r.json());
      if (!geoO[0] || !geoD[0]) { showToast("ZIP code não encontrado.", false); setCalculatingMiles(false); return; }
      const route = await fetch(`https://router.project-osrm.org/route/v1/driving/${geoO[0].lon},${geoO[0].lat};${geoD[0].lon},${geoD[0].lat}?overview=false`).then(r => r.json());
      const miles = (route.routes[0].distance / 1609.344).toFixed(0);
      setForm(p => ({ ...p, milhas: miles }));
      showToast(`✅ ${miles} milhas calculadas!`);
    } catch (e) { showToast("Erro ao calcular milhas.", false); }
    setCalculatingMiles(false);
  }

  function handleSubmit() {
    if (!form.origemEndereco && !form.origem) { showToast("Preencha o endereço de origem.", false); return; }
    if (!form.destinoEndereco && !form.destino) { showToast("Preencha o endereço de destino.", false); return; }
    if (!form.valor) { showToast("Preencha o valor.", false); return; }
    const origemStr = form.origemEndereco ? `${form.origemNumero} ${form.origemEndereco}, ${form.origemLocal} ${form.origemZip}`.trim() : form.origem;
    const destinoStr = form.destinoEndereco ? `${form.destinoNumero} ${form.destinoEndereco}, ${form.destinoLocal} ${form.destinoZip}`.trim() : form.destino;
    const entry = { ...form, id: editId || Date.now(), origem: origemStr, destino: destinoStr, valor: Number(form.valor), milhas: Number(form.milhas || 0) };
    if (editId) {
      setServices(prev => prev.map(s => s.id === editId ? entry : s));
      showToast("Serviço atualizado!");
    } else {
      setServices(prev => [entry, ...prev]);
      showToast("Serviço adicionado!");
    }
    setForm(emptyForm); setEditId(null); setTab("dashboard");
  }

  function handleEdit(s) { setForm({ ...emptyForm, ...s, valor: String(s.valor), milhas: String(s.milhas) }); setEditId(s.id); setTab("novo"); }
  function handleDelete(id) { setServices(prev => prev.filter(s => s.id !== id)); setShowDeleteId(null); showToast("Serviço removido."); }
  const rateColor = (milhas, valor) => !milhas || milhas == 0 ? "#a0aec0" : valor / milhas >= MIN_RATE_PER_MILE ? "#48bb78" : "#fc8181";

  const allEvents = useMemo(() => {
    const evs = [];
    services.forEach(s => {
      if (s.dataPickup) evs.push({ ...s, _date: s.dataPickup, _time: s.horaPickup || "08:00", _type: "pickup" });
      if (s.dataEntrega) evs.push({ ...s, _date: s.dataEntrega, _time: s.horaEntrega || "17:00", _type: "entrega", _isDelivery: true });
    });
    return evs;
  }, [services]);

  const eventsByDay = useMemo(() => {
    const map = {};
    allEvents.forEach(ev => { (map[ev._date] = map[ev._date] || []).push(ev); });
    return map;
  }, [allEvents]);

  const calDays = useMemo(() => {
    const first = new Date(calMonth.y, calMonth.m, 1);
    const last = new Date(calMonth.y, calMonth.m + 1, 0);
    const days = [];
    for (let i = 0; i < first.getDay(); i++) days.push(null);
    for (let d = 1; d <= last.getDate(); d++) {
      const key = `${calMonth.y}-${String(calMonth.m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      days.push({ d, key, events: eventsByDay[key] || [] });
    }
    return days;
  }, [calMonth, eventsByDay]);

  const selectedEvents = useMemo(() => (eventsByDay[selectedDay] || []).sort((a, b) => (a._time || "").localeCompare(b._time || "")), [eventsByDay, selectedDay]);
  const today = todayKey();
  const selDateObj = selectedDay ? new Date(selectedDay + "T12:00:00") : null;
  const selLabel = selDateObj ? `${DAYS_PT[selDateObj.getDay()]}, ${selDateObj.getDate()} de ${MONTHS_FULL[selDateObj.getMonth()].toLowerCase()} de ${selDateObj.getFullYear()}` : "";
  const HOURS = Array.from({ length: 19 }, (_, i) => i + 6);

  function handlePin(d) {
    var next = pin + d;
    setPin(next);
    setPinError(false);
    if (next.length === 4) {
      if (next === '1925') {
        sessionStorage.setItem('tc_auth','1');
        setUnlocked(true);
      } else {
        setPinError(true);
        setTimeout(function(){ setPin(''); setPinError(false); }, 700);
      }
    }
  }

  if (!unlocked) {
    return (
      <div style={{minHeight:'100vh',background:'#1a202c',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:24}}>
        <div style={{fontSize:48,marginBottom:16}}>🚛</div>
        <div style={{color:'#68d391',fontWeight:900,fontSize:24,letterSpacing:1,marginBottom:4}}>TC Moving</div>
        <div style={{color:'#718096',fontSize:12,marginBottom:40}}>Florida · Owner Dashboard</div>
        <div style={{display:'flex',gap:14,marginBottom:32}}>
          {[0,1,2,3].map(i => (
            <div key={i} style={{width:14,height:14,borderRadius:'50%',background:i<pin.length?(pinError?'#fc8181':'#68d391'):'#2d3748',border:'2px solid '+(i<pin.length?(pinError?'#fc8181':'#68d391'):'#4a5568'),transition:'all .15s'}} />
          ))}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,width:220}}>
          {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((d,i) => (
            <button key={i}
              onClick={() => { if(d==='⌫'){setPin(p=>p.slice(0,-1));setPinError(false);}else if(d!==''){handlePin(String(d));} }}
              style={{background:d===''?'transparent':'#2d3748',border:d===''?'none':'1px solid #4a5568',borderRadius:14,color:'#e2e8f0',fontSize:22,fontWeight:500,cursor:d===''?'default':'pointer',aspectRatio:'1',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'}}
              disabled={d===''}>
              {d}
            </button>
          ))}
        </div>
        {pinError && <div style={{color:'#fc8181',fontSize:13,marginTop:20}}>Senha incorreta</div>}
      </div>
    );
  }

  return (
    <div style={S.root}>
      {toast && <div style={{ ...S.toast, background: toast.ok ? "#276749" : "#9b2335" }}>{toast.ok ? "✓" : "!"} {toast.msg}</div>}

      {modalVariavel && <ModalVariavel onClose={() => setModalVariavel(false)} />}
      {modalManutencao && <ModalManutencao onClose={() => setModalManutencao(false)} />}
      {modalFixo && <ModalFixo onClose={() => setModalFixo(false)} />}

      <header style={{ background: "#171923", borderBottom: "1px solid #2d3748" }}>
        <div style={{ padding: "10px 16px 12px", borderBottom: "1px solid #2d3748" }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            {[["dashboard", "📊 Dashboard"], ["historico", "📋 Histórico"], ["agenda", "📅 Agenda"]].map(([id, label]) => (
              <button key={id} onClick={() => setTab(id)} style={{ ...S.navBtn, flex: 1, textAlign: "center", padding: "8px 4px", ...(tab === id ? S.navActive : {}) }}>{label}</button>
            ))}
          </div>
          <button onClick={() => { setTab("novo"); setForm(emptyForm); setEditId(null); }}
            style={{ ...S.navBtn, width: "100%", textAlign: "center", padding: "10px", fontWeight: 700, color: "#68d391", borderColor: "#276749", background: tab === "novo" ? "#276749" : "transparent", fontSize: 14, boxSizing: "border-box" }}>
            ➕ Novo Serviço
          </button>
        </div>
      </header>

      <main style={S.main}>
        {tab === "dashboard" && (
          <div>
            <div style={S.filterRow}>
              <select style={{ ...S.select, flex: 1 }} value={filterMonth} onChange={e => setFilterMonth(e.target.value)}>
                <option value="all">Todos os meses</option>
                {MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}
              </select>
              <select style={{ ...S.select, flex: 1 }} value={filterType} onChange={e => setFilterType(e.target.value)}>
                <option value="all">Todos os tipos</option>
                {SERVICE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
              <button onClick={() => setHideValues(v => !v)}
                style={{ flexShrink: 0, background: "transparent", border: hideValues ? "1px solid #68d391" : "1px solid #4a5568", borderRadius: 6, padding: "8px 10px", cursor: "pointer", display: "flex", alignItems: "center" }}>
                {hideValues ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#68d391" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>

            <div style={S.kpiGrid}>
              <KpiCard icon="💵" label="Receita Total" value={mask(formatCurrency(stats.total))} accent="#68d391" />
              <KpiCard icon="🚛" label="Serviços" value={stats.count} accent="#63b3ed" />
              <KpiCard icon="🛣️" label="Milhas Totais" value={`${stats.miles.toFixed(0)} mi`} accent="#f6ad55" />
              <KpiCard icon="📈" label="$/Milha Médio" value={mask(`${formatCurrency(stats.avgPerMile)}/mi`)} accent={stats.avgPerMile >= MIN_RATE_PER_MILE ? "#68d391" : "#fc8181"} />
              <KpiCard icon="✅" label="Recebido" value={mask(formatCurrency(stats.recebido))} accent="#68d391" />
              <div onClick={() => setShowPendingModal(true)} style={{ ...S.kpiCard, borderTop: "3px solid #f6ad55", cursor: "pointer" }}>
                <span style={{ fontSize: 28 }}>⏳</span>
                <div style={{ color: "#a0aec0", fontSize: 12, marginTop: 4 }}>A Receber</div>
                <div style={{ color: "#f6ad55", fontSize: 22, fontWeight: 800, marginTop: 2 }}>{mask(formatCurrency(stats.pendente))}</div>
                <div style={{ color: "#f6ad55", fontSize: 10, marginTop: 4, opacity: 0.7 }}>▶ Ver detalhes</div>
              </div>
            </div>

            {monthlyChart.length > 0 && (
              <div style={S.card}>
                <h2 style={S.cardTitle}>📈 Receita × Lucro por Mês</h2>
                <BarChart data={monthlyChart} hide={hideValues} />
              </div>
            )}

            <div style={S.card}>
              <h2 style={S.cardTitle}>📊 Distribuição da Receita</h2>
              <SplitBar label="Lucro (60%)" value={stats.lucro} color="#48bb78" pct={60} hide={hideValues} />
              <SplitBarClick label="⛽ Variável (25%)" value={stats.variavel} color="#63b3ed" pct={25} hide={hideValues} onClick={() => setModalVariavel(true)} />
              <SplitBarClick label="🔧 Manutenção (10%)" value={stats.manutencao} color="#f6ad55" pct={10} hide={hideValues} onClick={() => setModalManutencao(true)} />
              <SplitBarClick label="📋 Fixo (5%)" value={stats.fixo} color="#fc8181" pct={5} hide={hideValues} onClick={() => setModalFixo(true)} />
            </div>

            <div style={S.card}>
              <h2 style={S.cardTitle}>🗓️ Próximos Serviços</h2>
              {filtered.slice(0, 5).length === 0
                ? <p style={S.empty}>Nenhum serviço. Adicione o primeiro!</p>
                : filtered.slice(0, 5).map(s => <ServiceRow key={s.id} s={s} onEdit={() => handleEdit(s)} onDelete={() => setShowDeleteId(s.id)} rateColor={rateColor} expanded />)}
            </div>
          </div>
        )}

        {tab === "historico" && (
          <div>
            <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
              <select style={{ ...S.select, flex: 1 }} value={filterMonth} onChange={e => setFilterMonth(e.target.value)}>
                <option value="all">Todos os meses</option>
                {MONTHS.map((m, i) => <option key={i} value={i}>{m}</option>)}
              </select>
              <select style={{ ...S.select, flex: 1 }} value={filterType} onChange={e => setFilterType(e.target.value)}>
                <option value="all">Todos os tipos</option>
                {SERVICE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 14, color: "#68d391", fontWeight: 700, fontSize: 13 }}>{filtered.length} serviço(s) · {mask(formatCurrency(stats.total))}</div>
            <div style={S.card}>
              {filtered.length === 0 ? <p style={S.empty}>Nenhum serviço encontrado.</p>
                : filtered.map(s => <ServiceRow key={s.id} s={s} onEdit={() => handleEdit(s)} onDelete={() => setShowDeleteId(s.id)} rateColor={rateColor} expanded />)}
            </div>
          </div>
        )}

        {tab === "agenda" && (
          <div style={S.card}>
            <div style={S.calHeader}>
              <button style={S.calBtn} onClick={() => setCalMonth(p => { const d = new Date(p.y, p.m - 1); return { y: d.getFullYear(), m: d.getMonth() }; })}>‹</button>
              <h2 style={{ ...S.cardTitle, margin: 0 }}>{MONTHS_FULL[calMonth.m]} {calMonth.y}</h2>
              <button style={S.calBtn} onClick={() => setCalMonth(p => { const d = new Date(p.y, p.m + 1); return { y: d.getFullYear(), m: d.getMonth() }; })}>›</button>
            </div>
            <div style={S.calGrid7}>{DAYS_SHORT.map((d, i) => <div key={i} style={S.calDow}>{d}</div>)}</div>
            <div style={S.calGrid7}>
              {calDays.map((day, i) => {
                if (!day) return <div key={i} />;
                const isToday = day.key === today;
                const isSel = day.key === selectedDay;
                const types = [...new Set((day.events || []).map(e => e._type))];
                return (
                  <div key={i} style={S.calDayCell} onClick={() => setSelectedDay(day.key)}>
                    <div style={{ ...S.calDayNum, background: isToday ? "#e53e3e" : isSel ? "#276749" : "transparent", color: (isToday || isSel) ? "#fff" : "#e2e8f0" }}>{day.d}</div>
                    <div style={S.calDots}>
                      {types.includes("pickup") && <span style={{ ...S.dot, background: EV_COLORS.pickup.bg }} />}
                      {types.includes("entrega") && <span style={{ ...S.dot, background: EV_COLORS.entrega.bg }} />}
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ ...S.calLegend, marginTop: 10 }}>
              {Object.entries(EV_COLORS).map(([k, v]) => (
                <span key={k} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <span style={{ ...S.dot, background: v.bg, width: 10, height: 10 }} /> {v.label}
                </span>
              ))}
            </div>
            <div style={S.selDayLabel}>{selLabel}</div>
            <div style={S.timeline}>
              {selectedEvents.length === 0 && <p style={{ ...S.empty, paddingTop: 8 }}>Nenhum evento neste dia.</p>}
              {HOURS.map(h => {
                const hMod = h % 24;
                const slotEvents = selectedEvents.filter(ev => parseInt((ev._time || "00:00").split(":")[0]) === hMod);
                const isNowHour = new Date().getHours() === hMod && selectedDay === today;
                return (
                  <div key={h} style={{ display: "flex", alignItems: "flex-start", minHeight: 36 }}>
                    <div style={{ width: 60, fontSize: 10, color: isNowHour ? "#fc8181" : slotEvents.length > 0 ? "#cbd5e0" : "#4a5568", fontWeight: slotEvents.length > 0 ? 700 : 400, paddingRight: 8, textAlign: "right", flexShrink: 0, lineHeight: "22px" }}>
                      {fmt12(hMod)}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ borderTop: `1px solid ${isNowHour ? "#fc8181" : "#2d3748"}`, position: "relative" }}>
                        {isNowHour && <div style={{ position: "absolute", top: -5, left: -5, width: 9, height: 9, borderRadius: "50%", background: "#fc8181" }} />}
                      </div>
                      {slotEvents.map((ev, j) => {
                        const col = evColor(ev);
                        return (
                          <div key={j} onClick={() => setSelectedEvent(ev)}
                            style={{ height: 22, background: col.bg, borderLeft: `3px solid ${col.light}`, borderRadius: 4, cursor: "pointer", display: "flex", alignItems: "center", paddingLeft: 8, overflow: "hidden", marginTop: 1 }}>
                            <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
                              {ev._isDelivery ? "🏁" : "🚛"} {ev.origem?.split(" ")[0]} → {ev.destino?.split(" ")[0]} · {formatCurrency(ev.valor)}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === "novo" && (
          <div style={S.card}>
            <h2 style={S.cardTitle}>{editId ? "✏️ Editar Serviço" : "➕ Novo Serviço"}</h2>
            <div style={S.formGrid}>
              <label style={{ ...S.label, gridColumn: "1/-1" }}>Tipo de Serviço
                <select style={S.input} value={form.tipo} onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))}>
                  {SERVICE_TYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </label>
              <div style={{ gridColumn: "1/-1", background: "#1a202c", borderRadius: 8, padding: "12px 14px" }}>
                <div style={{ color: "#68d391", fontWeight: 800, fontSize: 13, marginBottom: 10 }}>📍 ORIGEM</div>
                <div style={S.formGrid}>
                  <label style={S.label}>Número<input style={S.input} placeholder="123" value={form.origemNumero} onChange={e => setForm(p => ({ ...p, origemNumero: e.target.value }))} /></label>
                  <label style={S.label}>Endereço<input style={S.input} placeholder="Main Street" value={form.origemEndereco} onChange={e => setForm(p => ({ ...p, origemEndereco: e.target.value }))} /></label>
                  <label style={S.label}>ZIP Code<input style={S.input} placeholder="44641" value={form.origemZip} onChange={e => setForm(p => ({ ...p, origemZip: e.target.value }))} onBlur={e => fetchCityFromZip(e.target.value, "origem")} /></label>
                  <label style={S.label}>Cidade / Estado<input style={S.input} placeholder="Louisville OH" value={form.origemLocal} onChange={e => setForm(p => ({ ...p, origemLocal: e.target.value }))} /></label>
                  <label style={{ ...S.label, gridColumn: "1/-1" }}>Contato<input style={S.input} placeholder="Nome / Telefone" value={form.origemContato} onChange={e => setForm(p => ({ ...p, origemContato: e.target.value }))} /></label>
                </div>
              </div>
              <div style={{ gridColumn: "1/-1", background: "#1a202c", borderRadius: 8, padding: "12px 14px" }}>
                <div style={{ color: "#63b3ed", fontWeight: 800, fontSize: 13, marginBottom: 10 }}>🏁 DESTINO</div>
                <div style={S.formGrid}>
                  <label style={S.label}>Número<input style={S.input} placeholder="456" value={form.destinoNumero} onChange={e => setForm(p => ({ ...p, destinoNumero: e.target.value }))} /></label>
                  <label style={S.label}>Endereço<input style={S.input} placeholder="Oak Avenue" value={form.destinoEndereco} onChange={e => setForm(p => ({ ...p, destinoEndereco: e.target.value }))} /></label>
                  <label style={S.label}>ZIP Code<input style={S.input} placeholder="27360" value={form.destinoZip} onChange={e => setForm(p => ({ ...p, destinoZip: e.target.value }))} onBlur={e => fetchCityFromZip(e.target.value, "destino")} /></label>
                  <label style={S.label}>Cidade / Estado<input style={S.input} placeholder="Thomasville NC" value={form.destinoLocal} onChange={e => setForm(p => ({ ...p, destinoLocal: e.target.value }))} /></label>
                  <label style={{ ...S.label, gridColumn: "1/-1" }}>Contato<input style={S.input} placeholder="Nome / Telefone" value={form.destinoContato} onChange={e => setForm(p => ({ ...p, destinoContato: e.target.value }))} /></label>
                </div>
              </div>
              <div style={{ gridColumn: "1/-1", display: "flex", gap: 10, alignItems: "flex-end" }}>
                <label style={{ ...S.label, flex: 1 }}>🛣️ Milhas<input style={S.input} type="number" placeholder="Inserir manualmente" value={form.milhas} onChange={e => setForm(p => ({ ...p, milhas: e.target.value }))} /></label>
                <button style={{ ...S.btnPrimary, height: 44, fontSize: 12, padding: "0 14px", opacity: calculatingMiles ? 0.6 : 1 }} onClick={calcMilhasOSRM} disabled={calculatingMiles}>
                  {calculatingMiles ? "⏳ Calculando..." : "📍 Auto-calcular"}
                </button>
              </div>
              {form.milhas && Number(form.milhas) > 0 && form.valor && (
                <div style={{ gridColumn: "1/-1", background: "#1a202c", borderRadius: 6, padding: "8px 12px", fontSize: 12, color: "#a0aec0" }}>
                  📊 {form.milhas} mi · {formatCurrency(form.valor / form.milhas)}/mi
                  <span style={{ marginLeft: 10, color: form.valor / form.milhas >= MIN_RATE_PER_MILE ? "#68d391" : "#fc8181", fontWeight: 700 }}>
                    {form.valor / form.milhas >= MIN_RATE_PER_MILE ? "✅ Compensa!" : "⚠️ Abaixo de $1.50/mi"}
                  </span>
                </div>
              )}
              <label style={S.label}>⚖️ Peso (lbs)<input style={S.input} type="number" placeholder="500" value={form.peso} onChange={e => setForm(p => ({ ...p, peso: e.target.value }))} /></label>
              <label style={S.label}>📦 Nº de Peças<input style={S.input} type="number" placeholder="1" value={form.pecas} onChange={e => setForm(p => ({ ...p, pecas: e.target.value }))} /></label>
              <label style={S.label}>📅 Data Pickup<input style={S.input} type="date" value={form.dataPickup} onChange={e => setForm(p => ({ ...p, dataPickup: e.target.value }))} /></label>
              <label style={S.label}>🕐 Hora Pickup<input style={S.input} type="time" value={form.horaPickup} onChange={e => setForm(p => ({ ...p, horaPickup: e.target.value }))} /></label>
              <label style={S.label}>📅 Data Entrega<input style={S.input} type="date" value={form.dataEntrega} onChange={e => setForm(p => ({ ...p, dataEntrega: e.target.value }))} /></label>
              <label style={S.label}>🕐 Hora Entrega<input style={S.input} type="time" value={form.horaEntrega} onChange={e => setForm(p => ({ ...p, horaEntrega: e.target.value }))} /></label>
              <label style={S.label}>💰 Data Pagamento<input style={S.input} type="date" value={form.dataPagamento} onChange={e => setForm(p => ({ ...p, dataPagamento: e.target.value }))} /></label>
              <label style={S.label}>🕐 Hora Pagamento<input style={S.input} type="time" value={form.horaPagamento} onChange={e => setForm(p => ({ ...p, horaPagamento: e.target.value }))} /></label>
              <label style={{ ...S.label, justifyContent: "center" }}>Status
                <div onClick={() => setForm(p => ({ ...p, pago: !p.pago }))} style={{ ...S.pagoToggle, background: form.pago ? "#276749" : "#4a5568", cursor: "pointer" }}>
                  {form.pago ? "✅ PAGO" : "⏳ PENDENTE"}
                </div>
              </label>
              <label style={{ ...S.label, gridColumn: "1/-1" }}>💵 Valor ($)
                <input style={{ ...S.input, fontSize: 22, fontWeight: 700, color: "#68d391" }} type="number" placeholder="450" value={form.valor} onChange={e => setForm(p => ({ ...p, valor: e.target.value }))} />
              </label>
              <label style={{ ...S.label, gridColumn: "1/-1" }}>💬 Notas
                <textarea style={{ ...S.input, height: 70, resize: "vertical" }} placeholder="Observações..." value={form.notas} onChange={e => setForm(p => ({ ...p, notas: e.target.value }))} />
              </label>
            </div>
            <div style={S.btnRow}>
              <button style={S.btnSecondary} onClick={() => { setForm(emptyForm); setEditId(null); setTab("dashboard"); }}>Cancelar</button>
              <button style={S.btnPrimary} onClick={handleSubmit}>{editId ? "Salvar Edição" : "Adicionar Serviço"}</button>
            </div>
          </div>
        )}
      </main>

      {showDeleteId && (
        <div style={S.overlay}>
          <div style={S.modal}>
            <p style={{ fontSize: 18, marginBottom: 16 }}>Remover este serviço?</p>
            <div style={S.btnRow}>
              <button style={S.btnSecondary} onClick={() => setShowDeleteId(null)}>Cancelar</button>
              <button style={{ ...S.btnPrimary, background: "#e53e3e" }} onClick={() => handleDelete(showDeleteId)}>Remover</button>
            </div>
          </div>
        </div>
      )}

      {selectedEvent && (
        <div style={S.overlay} onClick={() => setSelectedEvent(null)}>
          <div style={{ ...S.modal, minWidth: 300, maxWidth: 440, width: "90%", textAlign: "left" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <h2 style={{ fontSize: 15, fontWeight: 800 }}>{selectedEvent._isDelivery ? "🏁 Entrega" : "🚛 Pickup"}</h2>
              <button style={S.closeBtn} onClick={() => setSelectedEvent(null)}>✕</button>
            </div>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 8 }}>{selectedEvent.origem} → {selectedEvent.destino}</div>
            <div style={{ color: "#a0aec0", fontSize: 12, marginBottom: 4 }}>{selectedEvent.tipo}</div>
            {selectedEvent._date && <div style={{ color: "#a0aec0", fontSize: 12, marginBottom: 4 }}>📅 {formatDate(selectedEvent._date)} às {fmt12(selectedEvent._time)}</div>}
            {selectedEvent.dataEntrega && <div style={{ color: "#63b3ed", fontSize: 12, marginBottom: 4 }}>🏁 Entrega: {formatDate(selectedEvent.dataEntrega)}</div>}
            {selectedEvent.milhas > 0 && <div style={{ color: "#a0aec0", fontSize: 12, marginBottom: 4 }}>🛣️ {selectedEvent.milhas} mi · ⚖️ {selectedEvent.peso || "-"} lbs</div>}
            {selectedEvent.notas && <div style={{ color: "#718096", fontSize: 12, marginBottom: 8 }}>💬 {selectedEvent.notas}</div>}
            <div style={{ borderTop: "1px solid #4a5568", paddingTop: 10, marginTop: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: "#68d391", fontWeight: 800, fontSize: 20 }}>{formatCurrency(selectedEvent.valor)}</div>
                <div style={{ color: "#718096", fontSize: 11 }}>Lucro: {formatCurrency(selectedEvent.valor * BUSINESS_SPLIT.lucro)}</div>
              </div>
              <span style={{ background: selectedEvent.pago ? "#276749" : "#744210", color: selectedEvent.pago ? "#9ae6b4" : "#fbd38d", borderRadius: 6, padding: "4px 12px", fontSize: 12, fontWeight: 700 }}>
                {selectedEvent.pago ? "✅ Pago" : "⏳ Pendente"}
              </span>
            </div>
          </div>
        </div>
      )}

      {showPendingModal && (
        <div style={S.overlay} onClick={() => setShowPendingModal(false)}>
          <div style={{ ...S.modal, minWidth: 320, maxWidth: 480, width: "90%", maxHeight: "80vh", overflowY: "auto", textAlign: "left" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h2 style={{ fontSize: 16, fontWeight: 800, color: "#fbd38d" }}>⏳ A Receber</h2>
              <button style={S.closeBtn} onClick={() => setShowPendingModal(false)}>✕</button>
            </div>
            {services.filter(s => !s.pago).length === 0 ? <p style={S.empty}>Nenhum pagamento pendente!</p> : (
              <>
                {services.filter(s => !s.pago).sort((a, b) => new Date(a.dataPagamento || "9999") - new Date(b.dataPagamento || "9999")).map(s => (
                  <div key={s.id} style={{ borderBottom: "1px solid #4a5568", paddingBottom: 14, marginBottom: 14 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14 }}>{s.origem} → {s.destino}</div>
                        <div style={{ color: "#a0aec0", fontSize: 12, marginTop: 3 }}>{s.tipo}</div>
                        {s.dataPagamento && <div style={{ color: "#fbd38d", fontSize: 12, marginTop: 3 }}>💰 Pgto: {formatDate(s.dataPagamento)}</div>}
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0, marginLeft: 12 }}>
                        <div style={{ color: "#f6ad55", fontWeight: 800, fontSize: 18 }}>{formatCurrency(s.valor)}</div>
                        <button style={{ ...S.btnPrimary, fontSize: 11, padding: "5px 12px", marginTop: 6 }}
                          onClick={() => { setServices(prev => prev.map(x => x.id === s.id ? { ...x, pago: true } : x)); showToast("Marcado como pago!"); }}>
                          ✅ Marcar Pago
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{ borderTop: "2px solid #4a5568", paddingTop: 12, display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color: "#a0aec0", fontWeight: 700 }}>Total:</span>
                  <span style={{ color: "#f6ad55", fontWeight: 800, fontSize: 18 }}>{formatCurrency(stats.pendente)}</span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function KpiCard({ icon, label, value, accent }) {
  return (
    <div style={{ ...S.kpiCard, borderTop: `3px solid ${accent}` }}>
      <span style={{ fontSize: 28 }}>{icon}</span>
      <div style={{ color: "#a0aec0", fontSize: 12, marginTop: 4 }}>{label}</div>
      <div style={{ color: accent, fontSize: 22, fontWeight: 800, marginTop: 2 }}>{value}</div>
    </div>
  );
}

function SplitBar({ label, value, color, pct, hide }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <span style={{ color: "#cbd5e0", fontSize: 13 }}>{label}</span>
        <span style={{ color, fontWeight: 700 }}>{hide ? "••••••" : formatCurrency(value)}</span>
      </div>
      <div style={{ background: "#1a202c", borderRadius: 6, height: 10, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, background: color, height: "100%", borderRadius: 6 }} />
      </div>
    </div>
  );
}

function SplitBarClick({ label, value, color, pct, hide, onClick }) {
  return (
    <div style={{ marginBottom: 10, cursor: "pointer", padding: "10px 12px", borderRadius: 8, border: "1px solid #4a5568", background: "#1a202c" }} onClick={onClick}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6, alignItems: "center" }}>
        <span style={{ color: "#cbd5e0", fontSize: 13, fontWeight: 700 }}>{label}</span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ color, fontWeight: 700 }}>{hide ? "••••••" : formatCurrency(value)}</span>
          <span style={{ color: "#718096", fontSize: 10 }}>▶ Detalhes</span>
        </div>
      </div>
      <div style={{ background: "#2d3748", borderRadius: 6, height: 8, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, background: color, height: "100%", borderRadius: 6 }} />
      </div>
    </div>
  );
}

function ServiceRow({ s, onEdit, onDelete, rateColor, expanded }) {
  const rate = s.milhas > 0 ? s.valor / s.milhas : 0;
  const rc = rateColor(s.milhas, s.valor);
  return (
    <div style={S.serviceRow}>
      <div style={{ flex: 1 }}>
        <div style={S.serviceHeader}>
          <span style={S.typeTag}>{s.tipo?.split(" ")[0]}</span>
          <span style={S.route}>{s.origem} → {s.destino}</span>
        </div>
        <div style={S.serviceMeta}>
          {s.milhas > 0 && <><span>🛣️ {s.milhas} mi</span>&nbsp;·&nbsp;</>}
          {s.peso && <><span>⚖️ {s.peso} lbs</span>&nbsp;·&nbsp;</>}
          {s.dataPickup && <span>🚛 {formatDate(s.dataPickup)}{s.horaPickup ? ` ${fmt12(s.horaPickup)}` : ""}</span>}
          {s.dataEntrega && <span>&nbsp;→ 🏁 {formatDate(s.dataEntrega)}</span>}
        </div>
        {expanded && s.notas && <div style={{ color: "#718096", fontSize: 12, marginTop: 4 }}>💬 {s.notas}</div>}
      </div>
      <div style={S.serviceRight}>
        <div style={{ color: "#68d391", fontWeight: 800, fontSize: 20 }}>{formatCurrency(s.valor)}</div>
        {s.milhas > 0 && <div style={{ color: rc, fontSize: 12, fontWeight: 600 }}>{formatCurrency(rate)}/mi</div>}
        <div style={{ fontSize: 11, color: "#718096", marginTop: 2 }}>Lucro: {formatCurrency(s.valor * BUSINESS_SPLIT.lucro)}</div>
        <div style={{ marginTop: 4 }}>
          <span style={{ ...S.pagoBadge, background: s.pago ? "#276749" : "#744210", color: s.pago ? "#9ae6b4" : "#fbd38d" }}>
            {s.pago ? "✅ Pago" : "⏳ Pendente"}
          </span>
        </div>
        <div style={S.actionRow}>
          <button style={S.iconBtn} onClick={onEdit}>✏️</button>
          <button style={S.iconBtn} onClick={onDelete}>🗑️</button>
        </div>
      </div>
    </div>
  );
}

function BarChart({ data, hide }) {
  const maxVal = Math.max(...data.map(d => d.receita), 1);
  return (
    <div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 8, height: 120, paddingBottom: 4 }}>
        {data.map((d, i) => (
          <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
            <div style={{ width: "100%", display: "flex", gap: 2, alignItems: "flex-end", height: 100 }}>
              <div style={{ flex: 1, background: "#276749", borderRadius: "3px 3px 0 0", height: `${(d.receita / maxVal) * 100}%`, minHeight: 4 }} title={`Receita: ${formatCurrency(d.receita)}`} />
              <div style={{ flex: 1, background: "#48bb78", borderRadius: "3px 3px 0 0", height: `${(d.lucro / maxVal) * 100}%`, minHeight: 4 }} title={`Lucro: ${formatCurrency(d.lucro)}`} />
            </div>
            <div style={{ fontSize: 10, color: "#718096", fontWeight: 600 }}>{d.label}</div>
            {!hide && <div style={{ fontSize: 9, color: "#48bb78", fontWeight: 700 }}>{formatCurrency(d.receita)}</div>}
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 8, justifyContent: "center" }}>
        <span style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "#a0aec0" }}><span style={{ width: 10, height: 10, background: "#276749", borderRadius: 2, display: "inline-block" }} /> Receita</span>
        <span style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "#a0aec0" }}><span style={{ width: 10, height: 10, background: "#48bb78", borderRadius: 2, display: "inline-block" }} /> Lucro (60%)</span>
      </div>
    </div>
  );
}

const S = {
  root: { minHeight: "100vh", background: "#1a202c", color: "#e2e8f0", fontFamily: "'Courier New', monospace" },
  navBtn: { background: "transparent", border: "1px solid #4a5568", color: "#a0aec0", borderRadius: 6, padding: "6px 14px", cursor: "pointer", fontSize: 13, fontFamily: "inherit" },
  navActive: { background: "#276749", borderColor: "#276749", color: "#fff", fontWeight: 700 },
  main: { maxWidth: 1100, margin: "0 auto", padding: "24px 16px" },
  toast: { position: "fixed", top: 20, right: 20, padding: "12px 24px", borderRadius: 8, color: "#fff", fontWeight: 700, zIndex: 9999, fontSize: 14 },
  filterRow: { display: "flex", gap: 10, marginBottom: 20, alignItems: "center" },
  select: { background: "#2d3748", border: "1px solid #4a5568", color: "#e2e8f0", padding: "8px 12px", borderRadius: 6, fontSize: 13, fontFamily: "inherit" },
  kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 14, marginBottom: 20 },
  kpiCard: { background: "#2d3748", borderRadius: 10, padding: "16px 20px", display: "flex", flexDirection: "column" },
  card: { background: "#2d3748", borderRadius: 12, padding: "20px 24px", marginBottom: 20 },
  cardTitle: { fontSize: 16, fontWeight: 800, marginBottom: 16 },
  serviceRow: { display: "flex", gap: 12, padding: "14px 0", borderBottom: "1px solid #4a5568", alignItems: "flex-start" },
  serviceHeader: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  typeTag: { background: "#1a202c", color: "#63b3ed", fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 4 },
  route: { fontWeight: 700, fontSize: 15 },
  serviceMeta: { color: "#a0aec0", fontSize: 12, marginTop: 5, display: "flex", flexWrap: "wrap" },
  serviceRight: { textAlign: "right", minWidth: 120 },
  actionRow: { display: "flex", gap: 6, justifyContent: "flex-end", marginTop: 6 },
  iconBtn: { background: "none", border: "none", cursor: "pointer", fontSize: 16, padding: 2 },
  empty: { color: "#718096", textAlign: "center", padding: 24, fontSize: 14 },
  formGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 },
  label: { display: "flex", flexDirection: "column", gap: 6, fontSize: 12, color: "#a0aec0", fontWeight: 600, marginBottom: 12 },
  input: { background: "#1a202c", border: "1px solid #4a5568", color: "#e2e8f0", padding: "10px 12px", borderRadius: 7, fontSize: 15, fontFamily: "inherit", outline: "none" },
  miniInput: { background: "#1a202c", border: "1px solid #4a5568", color: "#e2e8f0", padding: "4px 6px", borderRadius: 5, width: 80, textAlign: "right", fontFamily: "inherit", fontSize: 12, outline: "none" },
  btnRow: { display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 20 },
  btnPrimary: { background: "#276749", color: "#fff", border: "none", borderRadius: 7, padding: "10px 24px", fontWeight: 800, fontSize: 14, cursor: "pointer", fontFamily: "inherit" },
  btnSecondary: { background: "#4a5568", color: "#e2e8f0", border: "none", borderRadius: 7, padding: "10px 24px", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "inherit" },
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: 16 },
  modal: { background: "#2d3748", borderRadius: 12, padding: "28px 32px", minWidth: 280, textAlign: "center" },
  closeBtn: { background: "none", border: "none", color: "#a0aec0", fontSize: 20, cursor: "pointer" },
  pagoToggle: { display: "inline-block", borderRadius: 7, padding: "10px 0", textAlign: "center", fontWeight: 800, fontSize: 14, color: "#fff", width: "100%", userSelect: "none", letterSpacing: 1 },
  pagoBadge: { display: "inline-block", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700 },
  calHeader: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 },
  calBtn: { background: "#4a5568", border: "none", color: "#e2e8f0", borderRadius: 6, padding: "6px 16px", fontSize: 18, cursor: "pointer" },
  calGrid7: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, marginBottom: 2 },
  calDow: { textAlign: "center", fontSize: 11, color: "#718096", fontWeight: 700, padding: "4px 0" },
  calDayCell: { display: "flex", flexDirection: "column", alignItems: "center", padding: "3px 0", cursor: "pointer" },
  calDayNum: { width: 30, height: 30, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, marginBottom: 3 },
  calDots: { display: "flex", gap: 2, height: 7 },
  dot: { display: "inline-block", width: 6, height: 6, borderRadius: "50%", flexShrink: 0 },
  selDayLabel: { textAlign: "center", color: "#a0aec0", fontSize: 13, fontWeight: 600, margin: "12px 0 10px", borderTop: "1px solid #4a5568", paddingTop: 12 },
  timeline: { overflowY: "visible" },
  calLegend: { marginTop: 16, display: "flex", gap: 16, color: "#a0aec0", fontSize: 12, flexWrap: "wrap", justifyContent: "center" },
};
